/* Mahlgrad Guide – gemeinsames Script für alle mg-* Sections.
   Wird von jeder Section eingebunden, läuft aber nur einmal. */
(function () {
  if (window.__mahlgradGuide) return;
  window.__mahlgradGuide = true;

  var MAX = 1500;
  var browns = ['#3A2214', '#4A2C1A', '#5C3620', '#6B4027', '#7D4E2E', '#2E1B10'];

  function rng(seed) {
    return function () {
      seed |= 0; seed = seed + 0x6D2B79F5 | 0;
      var t = Math.imul(seed ^ seed >>> 15, 1 | seed);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function shard(ctx, x, y, r, rand) {
    var n = 5 + Math.floor(rand() * 3), a0 = rand() * Math.PI * 2;
    ctx.beginPath();
    for (var i = 0; i < n; i++) {
      var a = a0 + i / n * Math.PI * 2, rr = r * (0.65 + rand() * 0.45);
      var px = x + Math.cos(a) * rr, py = y + Math.sin(a) * rr;
      if (i) ctx.lineTo(px, py); else ctx.moveTo(px, py);
    }
    ctx.closePath(); ctx.fill();
  }

  /* Pulverproben: <canvas class="mg-sw" data-um="725"> */
  function drawPowder(c, idx) {
    var w = c.clientWidth || 48, h = c.clientHeight || 48, dpr = window.devicePixelRatio || 1;
    if (!w || !h) return;
    c.width = Math.round(w * dpr); c.height = Math.round(h * dpr);
    var ctx = c.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var um = +c.getAttribute('data-um') || 500;
    var d = Math.max(0.7, um / MAX * 14), rand = rng(7 + idx);
    var count = Math.ceil((w * h) / (d * d) * 1.15);
    for (var i = 0; i < count; i++) {
      var dd = d * (0.7 + rand() * 0.6);
      ctx.fillStyle = browns[Math.floor(rand() * browns.length)];
      var x = rand() * (w + dd) - dd / 2, y = rand() * (h + dd) - dd / 2;
      if (dd < 2.2) ctx.fillRect(x, y, dd, dd); else shard(ctx, x, y, dd / 2, rand);
    }
  }
  function drawAll() {
    document.querySelectorAll('.mg canvas.mg-sw').forEach(drawPowder);
  }

  /* FAQ: immer nur eine Frage offen */
  function initFaq(root) {
    root.querySelectorAll('.mg-faq-list').forEach(function (list) {
      if (list.__mg) return; list.__mg = true;
      var items = list.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* Band im Finder: Körnung von fein (links) bis grob (rechts) */
  function drawBand(c) {
    var w = c.clientWidth, h = c.clientHeight, dpr = window.devicePixelRatio || 1;
    if (!w || !h) return;
    c.width = Math.round(w * dpr); c.height = Math.round(h * dpr);
    var ctx = c.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, w, h);
    var rand = rng(42), x = 0;
    while (x < w) {
      var d = Math.max(0.7, (x / w * MAX) / MAX * 14), per = Math.ceil(h / (d * 0.85));
      for (var i = 0; i < per; i++) {
        var dd = d * (0.7 + rand() * 0.6);
        ctx.fillStyle = browns[Math.floor(rand() * browns.length)];
        var px = x + (rand() - 0.5) * d, py = rand() * (h + dd) - dd / 2;
        if (dd < 2.2) ctx.fillRect(px, py, dd, dd); else shard(ctx, px, py, dd / 2, rand);
      }
      x += Math.max(0.5, d * 0.62);
    }
  }

  /* Seitlich scrollbare Icon-Leisten: Ausblendkanten und aktives Icon sichtbar halten */
  function fadeFor(row) {
    var max = row.scrollWidth - row.clientWidth;
    row.classList.toggle('fade-l', row.scrollLeft > 4);
    row.classList.toggle('fade-r', max > 4 && row.scrollLeft < max - 4);
  }
  function reveal(row, smooth) {
    var b = row.querySelector('[aria-pressed="true"]'); if (!b) return;
    var max = row.scrollWidth - row.clientWidth;
    var l = b.offsetLeft - row.offsetLeft, r = l + b.offsetWidth, vl = row.scrollLeft, vr = vl + row.clientWidth, target = null;
    if (r > vr - 64) target = r + 64 - row.clientWidth;
    else if (l < vl + 48 && vl > 0) target = l - 48;
    if (target === null) return;
    target = Math.max(0, Math.min(max, target));
    if (Math.abs(target - vl) < 2) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { row.scrollTo({ left: target, behavior: smooth && !reduce ? 'smooth' : 'auto' }); } catch (e) { row.scrollLeft = target; }
  }
  function rows() { return document.querySelectorAll('.mg .mg-mrow'); }
  function initRow(row) {
    if (row.__mg) return; row.__mg = true;
    row.addEventListener('scroll', function () { fadeFor(row); }, { passive: true });
    fadeFor(row);
  }

  /* Methoden: Rezeptauswahl + Finder teilen sich eine Auswahl */
  var KEY = 'mahlgrad-method';
  function brews() { return [].slice.call(document.querySelectorAll('.mg-methoden .mg-brew')); }
  function find(id) { return brews().filter(function (a) { return a.getAttribute('data-id') === id; })[0]; }
  function select(id, opts) {
    opts = opts || {};
    var brew = find(id); if (!brew) return;
    brews().forEach(function (a) {
      var on = a === brew, was = a.classList.contains('is-on');
      a.classList.toggle('is-on', on);
      if (on && !was && opts.animate) { a.classList.remove('swap'); void a.offsetWidth; a.classList.add('swap'); }
    });
    document.querySelectorAll('.mg .mg-mbtn').forEach(function (b) {
      var on = b.getAttribute('data-id') === id;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.getAttribute('role') === 'tab') b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    rows().forEach(function (r) { reveal(r, !!opts.animate); });
    updateFinder(brew);
    if (opts.save) { try { localStorage.setItem(KEY, id); } catch (e) {} }
  }
  function updateFinder(brew) {
    document.querySelectorAll('.mg-finder').forEach(function (f) {
      var d = brew.dataset, min = +d.min || 0, max = +d.max || min;
      var range = f.querySelector('.mg-range'), lab = f.querySelector('.mg-range-label');
      if (range) { range.style.left = (min / MAX * 100) + '%'; range.style.width = (Math.max(max - min, 20) / MAX * 100) + '%'; }
      if (lab) { lab.textContent = d.um || (min + '–' + max + ' µm'); lab.classList.toggle('is-left', min < 150); lab.classList.toggle('is-right', max > MAX - 150); }
      var map = { grind: d.grind, feel: d.feel, time: d.time, ratio: d.ratio, temp: d.temp };
      Object.keys(map).forEach(function (k) {
        var el = f.querySelector('[data-out="' + k + '"]'); if (!el) return;
        el.textContent = map[k] || '–';
        el.parentNode.hidden = !map[k];
      });
      var link = f.querySelector('.mg-finder-link');
      if (link) { link.href = '#' + d.id; link.textContent = (link.getAttribute('data-prefix') || '') + ' ' + d.name + ' →'; }
    });
  }
  function buildChips() {
    var tabs = document.querySelector('.mg-methoden .mg-brew-tabs');
    document.querySelectorAll('.mg-finder .mg-chips').forEach(function (chips) {
      if (!tabs) { chips.closest('.mg-finder').hidden = true; return; }
      chips.innerHTML = '';
      [].forEach.call(tabs.querySelectorAll('.mg-mbtn'), function (b, i) {
        var c = b.cloneNode(true);
        c.removeAttribute('role'); c.removeAttribute('aria-selected'); c.removeAttribute('aria-controls');
        c.style.setProperty('--rot', ((i * 67) % 360) + 'deg');
        chips.appendChild(c);
      });
    });
  }
  function initMethods() {
    if (!document.querySelector('.mg-methoden .mg-brew')) {
      document.querySelectorAll('.mg-finder').forEach(function (f) { f.hidden = true; });
      return;
    }
    buildChips();
    var start = null;
    if (location.hash && find(location.hash.slice(1))) start = location.hash.slice(1);
    if (!start) { try { var s = localStorage.getItem(KEY); if (s && find(s)) start = s; } catch (e) {} }
    if (!start) { var on = document.querySelector('.mg-methoden .mg-brew.is-on') || brews()[0]; start = on.getAttribute('data-id'); }
    select(start, {});
    rows().forEach(initRow);
    document.querySelectorAll('.mg-finder canvas.mg-band').forEach(drawBand);
  }
  if (!window.__mahlgradClicks) {
    window.__mahlgradClicks = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.mg .mg-mbtn');
      if (btn) { select(btn.getAttribute('data-id'), { save: true, animate: true }); return; }
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (a && a.getAttribute('href').length > 1 && find(a.getAttribute('href').slice(1))) select(a.getAttribute('href').slice(1), { save: true, animate: true });
    });
    document.addEventListener('keydown', function (e) {
      var btn = e.target.closest && e.target.closest('.mg .mg-mbtn[role="tab"]');
      if (!btn || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var all = [].slice.call(btn.parentNode.querySelectorAll('.mg-mbtn')), i = all.indexOf(btn);
      var next = all[(i + (e.key === 'ArrowRight' ? 1 : -1) + all.length) % all.length];
      next.focus(); select(next.getAttribute('data-id'), { save: true, animate: true }); e.preventDefault();
    });
  }

  function init() { drawAll(); initFaq(document); initMethods(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { drawAll(); document.querySelectorAll('.mg-finder canvas.mg-band').forEach(drawBand); rows().forEach(fadeFor); }, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { drawAll(); rows().forEach(fadeFor); });

  /* Theme-Editor: neu geladene Sections sofort zeichnen */
  document.addEventListener('shopify:section:load', function (e) { drawAll(); initFaq(e.target); initMethods(); });
  document.addEventListener('shopify:block:select', function (e) {
    var brew = e.target.closest && e.target.closest('.mg-brew');
    if (brew) select(brew.getAttribute('data-id'), {});
  });
})();
